
import { defineComponent } from 'vue'
import moment from 'moment';

export default defineComponent({
    name: "Zone Date Time",
    data: ()=>({
        content: { } as any
    }),

    props: {
        zoneContent: {
            type: Object,
            default: null
        },
        zoneNumber: {
            type: Number,
            default: null
        },
        zoneType: {
            type: String,
            default: null
        },
        contentName: {
            type: String,
            default: null
        }
    },

    computed: {
        longDataLabel() {
            const locale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language ?? 'en';
            moment.locale(locale);

            return `Long date: ${moment().format('LL')}`;
        },

        shortDataLabel() {
            return `Short date: ${moment().format('L')}`;
        }
    },

    watch: {
        'content': {
            handler(newValue: any){
                const current = this.zoneContent?.content ?? {};
                if (JSON.stringify(newValue) !== JSON.stringify(current)) {
                this.$emit('updateSignageZones', {zoneNumber: this.zoneNumber, zoneType: this.zoneType, updatedContent: newValue});
                }
            },
            deep: true
        },
         zoneContent: {
            immediate: true,
            deep: true,
             handler(newVal) {
             if (!newVal || typeof newVal !== 'object' || !newVal.content) {
                this.content = {
                    showDay: true,
                    showDate: true,
                    dateFormat: 'long',
                    showTime: true,
                    timeFormat24: false
                };
                return;
                }

                const content = newVal.content;

                if (newVal) {
                 const newVals = {
                    showDay: content.showDay ?? true,
                    showDate: content.showDate ?? true,
                    dateFormat: content.dateFormat ?? 'long',
                    showTime: content.showTime ?? true,
                    timeFormat24: content.timeFormat24 ?? false
                };

            if (JSON.stringify(this.content) !== JSON.stringify(newVals)) {
                this.content = newVals;
            }
            }
        }
        }
    }
})
